var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HeaderBanner',{staticClass:"not-found",attrs:{"image":_vm.header.image,"title":_vm.header.title,"description":_vm.header.description,"link":_vm.header.link,"button-text":_vm.header.buttonText,"sizes":_vm.header.sizes}})}
var staticRenderFns = []

export { render, staticRenderFns }